import { Button, Card, Col, Empty, Row, Skeleton, Space, Tabs, message } from 'antd';
import React, { useEffect, useState } from 'react';
import axios from '../backendServiceWithoutTimeout';
import Cookies from 'js-cookie';
import VideoSubjects from '../components/video-components/VideoSubjects';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ScheduleVideoModal from '../components/video-modals/ScheduleVideoModal';
import Heading from '../components/heading/heading';
import { PiUserCirclePlus } from 'react-icons/pi';
import UilPlus from '@iconscout/react-unicons/icons/uil-plus';
import AssignedCourseSkeleton from '../components/video-components/AssignedCourseSkeleton';

const VideoNew = () => {
  const [assignedCourses, setAssignedCourses] = useState([]);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const userId = Cookies.get('userId');
        // console.log(userId)
        const response = await axios.get(`users/getUserCourseData/${userId}`);
        console.log(response.data);
        const coursesData = response.data.courses; // Assuming this is the correct path
        setAssignedCourses(coursesData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {}, [assignedCourses]);

  const handleScheduleModal = () => {
    setShowScheduleModal(true);
  };

  const handleCancel = () => {
    setShowScheduleModal(false);
  };

  useEffect(() => {
    if (loading) {
      message.info({
        content: 'Please wait while we fetch your assigned courses',
        // duration: '1',
      });
    }
  }, [loading]);

  return (
    <div className="bg-white">
      <div className="flex items-center justify-between flex-wrap gap-[20px] ssm:flex-col pt-[42px] px-[25px] text-dark dark:text-white87 font-medium text-[17px]">
        <div className="inline-flex items-center">
          <Heading as="h4" className="text-dark dark:text-white87 text-[22px] font-semibold mb-0">
            Assigned Courses
          </Heading>
        </div>
      </div>
      <div className="p-6">
        {loading && assignedCourses.length === 0 ? (
          <AssignedCourseSkeleton />
        ) : assignedCourses.length === 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <Tabs
            title="Assigned Courses"
            className="flex min-w-max min-h-screen overflow-x-auto"
            defaultActiveKey="1"
            items={assignedCourses.map((course, index) => {
              return {
                label: course.courseName,
                key: index + 1,
                children: <VideoSubjects courseSubjects={course && course.subjects ? course.subjects : []} />,
              };
            })}
          />
        )}
      </div>
      <VideoSubjects />
      {/* <ScheduleVideoModal isVisible={showScheduleModal} handleCancel={handleCancel} /> */}
    </div>
  );
};

export default VideoNew;
